import {
  Grid,
} from "@material-ui/core";
import { Sidebar } from "../Sidebar";
import DocTable from "./DocTable";

export const DocPage = () => {
  return (
    <>
      <div style={{ marginTop: 80, display: 'flex' }}>
        <Sidebar />
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <DocTable />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
